<template>

  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="formInline.status" placeholder="商家状态">
            <el-option label="全部" value="-1"></el-option>
            <el-option v-for="(item,index) in status" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=""><el-input v-model="formInline.name" placeholder="商家名称"></el-input></el-form-item>
        <el-form-item><el-button icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>
    
    <!--添加商家-->
    <div class="common-level-rail">
      <div class="common-level-rail">
  <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick" v-auth="'/plus/supply/supply/add'">添加商家</el-button>
  <el-button size="small" icon="el-icon-upload" type="success" @click="importClick" v-auth="'/plus/supply/supply/import'">导入商家</el-button>
</div>

<!-- 导入商家弹窗 -->
<el-dialog title="导入商家" :visible.sync="open_import" width="500px">
  <div>
    <el-upload
      class="upload-demo"
      style="margin-top: 15px;"
      ref="upload"
      action=""
      :auto-upload="false"
      :on-change="handleFileChange"
      :file-list="fileList"
      accept=".xlsx,.xls">
      <el-button size="small" type="success" icon="el-icon-upload">选择Excel文件</el-button>
    </el-upload>
    
    <div style="margin-top: 15px; color: #666; font-size: 12px;">
      支持 .xlsx, .xls 格式文件，文件大小不超过10MB
    </div>
  </div>
  
  <div slot="footer" class="dialog-footer">
    <el-button @click="open_import = false">取消</el-button>
    <el-button type="primary" @click="submitImport" :loading="importLoading">开始导入</el-button>
  </div>
</el-dialog>
    </div>
    
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small"  :data="tableData" border style="width: 100%" v-loading="loading">
             <el-table-column prop="supply_id" label="商家ID"></el-table-column>
            <el-table-column prop="name" label="商家名称"></el-table-column>
            <el-table-column prop="user_id" label="关联用户ID" width="150"></el-table-column>
            <el-table-column label="账号" width="150" >
              <template slot-scope="scope">
              <span v-if="scope.row.shop_user">{{scope.row.shop_user.user_name}}</span>
            </template>	
            </el-table-column>
            <!-- <el-table-column prop="shanghui" label="所属商会"></el-table-column> -->
            <el-table-column label="商家等级">
              <template slot-scope="scope">
              <span>{{scope.row.kmd_grade.name}}</span>
            </template>	
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="150"></el-table-column>
            <el-table-column prop="is_default" label="是否默认">
                <template slot-scope="scope">
                  <el-switch
                    @change="setSupplyDefault(scope.row)"
                    v-model="scope.row.is_default"
                    active-color="#13ce66"
                    inactive-color="#c0c4cc">
                  </el-switch>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="启用/禁用" width="150">
                <template slot-scope="scope">
                    <el-switch 
                        active-text="启用"
                        v-model="scope.row.status"
                        :active-value="1"
                        :inactive-value="0"  
                        inactive-text="禁用" @change="handleStatus(scope.row)">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="product_num" label="商品数量"></el-table-column>
            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="190">
              <template slot-scope="scope">
                <el-button v-if="scope.row.audit_status == 0" @click="editClick(scope.row)" type="text" size="small">审核</el-button>
                <el-button @click="cardClick(scope.row)" type="text" size="small">补充信息</el-button>
                <el-button @click="masClick(scope.row)" type="text" size="small">工厂师傅</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="checkClick(scope.row)" type="text" size="small">查看详情</el-button>
                <el-button @click="orderClick(scope.row)" type="text" size="small">查看订单</el-button>
                <!-- <el-button @click="jumpClick(scope.row)" type="text" size="small">门店</el-button> -->
                <el-button @click="deleteClick(scope.row)" v-auth="'/plus/supply/supply/delete'" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <Oss :open_add="open_oss" :supply_id="supply_id" :form="obj"  v-if="open_oss"   @close="closeOss"></Oss>
    <Master :open_add="open_mas" :supply_id="supply_id" :form="obj"  v-if="open_mas"   @close="closeMas"></Master>
  </div>
</template>

<script>
import SupplyApi from '@/api/supply.js';
import Oss from './oss.vue';
import Master from './master.vue';
export default {
  components: {
    Oss,
    Master
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {},
      status: ['禁用', '启用'],
      open_oss:false,
      supply_id:0,
      open_mas:false,

        open_import: false,
    importLoading: false,
    fileList: [],
    importFile: null,
    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {
     /* 导入商家 */
  importClick() {
    this.open_import = true;
    this.fileList = [];
    this.importFile = null;
  },

  /* 下载模板 */
  downloadTemplate() {
    window.open('/api/supply/downloadTemplate', '_blank');
  },

  /* 文件选择 */
  handleFileChange(file, fileList) {
    this.fileList = fileList.slice(-1); // 只保留最后一个文件
    this.importFile = file;
  },

  /* 提交导入 */
/* 提交导入 */
submitImport() {
  if (!this.importFile) {
    this.$message.error('请选择要导入的文件');
    return;
  }

  this.importLoading = true;
  const formData = new FormData();
  formData.append('file', this.importFile.raw);

  SupplyApi.importSupply(formData)
    .then(data => {
      this.importLoading = false;
      if (data.code == 1) {
        const result = data.data;
        
        if (result.error > 0) {
          // 有失败记录，显示详细错误弹窗
          this.showImportResult(result);
        } else {
          // 全部成功
          this.$message.success(`导入成功，共导入 ${result.success} 条数据`);
          this.open_import = false;
          this.getTableList();
        }
      } else {
        this.$message.error(data.msg || '导入失败');
      }
    })
    .catch(error => {
      this.importLoading = false;
      this.$message.error('导入失败: ' + (error.msg || '网络错误'));
    });
},

/* 显示导入结果 */
showImportResult(result) {
  let htmlContent = `
    <div class="import-result">
      <div class="result-summary">
        <p>导入完成，成功: <span style="color: #67C23A;">${result.success}</span> 条，失败: <span style="color: #F56C6C;">${result.error}</span> 条</p>
      </div>
      <div class="error-details">
        <h4 style="margin: 0 0 12px 0; color: #606266;">失败详情:</h4>
        <div class="error-list" style="max-height: 300px; overflow-y: auto;">
  `;
  
  if (result.error_messages && result.error_messages.length > 0) {
    result.error_messages.forEach(error => {
      htmlContent += `
        <div class="error-item" style="margin: 8px 0; padding: 8px; background: #fef0f0; border-radius: 4px;">
          <div style="font-weight: bold; color: #F56C6C;">第 ${error.line} 行: ${error.message}</div>
          <div style="font-size: 12px; color: #909399; margin-top: 4px;">
            数据: ${error.data ? error.data.join(', ') : '无数据'}
          </div>
        </div>
      `;
    });
  } else if (result.errors && result.errors.length > 0) {
    // 兼容不同的错误信息格式
    result.errors.forEach((error, index) => {
      htmlContent += `
        <div class="error-item" style="margin: 8px 0; padding: 8px; background: #fef0f0; border-radius: 4px;">
          <div style="font-weight: bold; color: #F56C6C;">${error}</div>
        </div>
      `;
    });
  }
  
  htmlContent += `
        </div>
      </div>
    </div>
  `;
  
  this.$alert(htmlContent, '导入结果', {
    dangerouslyUseHTMLString: true,
    customClass: 'import-result-dialog',
    showConfirmButton: true,
    confirmButtonText: '确定',
    callback: action => {
      this.open_import = false;
      if (result.success > 0) {
        this.getTableList(); // 如果有成功的数据，刷新列表
      }
    }
  });
},
    cardClick(item){
      this.supply_id = item.supply_id;
      this.obj = item;
      this.open_oss = true;
    },
    closeOss(e){
      this.open_oss=false;
      this.getTableList();
    },
    masClick(item){
      this.supply_id = item.supply_id;
      this.obj = item;
      this.open_mas = true;
    },
    closeMas(e){
      this.open_mas=false;
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      SupplyApi.supplyList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          console.log(self.tableData)
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加活动*/
    addClick() {
      this.$router.push('/plus/supply/supply/add');
    },
    jumpClick(e){
      this.$router.push({
          path: '/store/index',
          query: {
            supply_id: e.supply_id
          }
        });
    },

    /*编辑活动*/
    editClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/supply/supply/edit',
        query: {
          supply_id: supply_id
        }
      });
    },
    // 查看详情
    checkClick(row){
        let supply_id = row.supply_id;
        this.$router.push({
          path: '/plus/supply/supply/detail',
          query: {
            supply_id: supply_id
          }
        });
    },
    // 查看商家订单
    orderClick(row){
        let supply_id = row.supply_id;
        this.$router.push({
          path: '/plus/supply/supply/order',
          query: {
            supply_id: 12
          }
        });
    },
    
    
    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          SupplyApi.delSupply(
            {
              supply_id: row.supply_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '商家删除成功',
                  type: 'success'
                });
                this.onSubmit();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    /* 
    *设置默认供应商
    */
    setSupplyDefault(item){
      let self = this;
      let form = {
        'supply_id':item.supply_id,
        'is_default':item.is_default,
        'operation':'setdefault',
      }
      SupplyApi.saveSupply(form, true)
      .then(data => {
        self.loading = false;
        
        if (data.code == 1) {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          self.getTableList();
        } else {
          self.loading = false;
        }
      })
      .catch(error => {
        self.loading = false;
      });
    },
    // 设置商家状态启用/禁用
    handleStatus(item){
      let self = this;
      let form = {
        'supply_id':item.supply_id,
        'status':item.status,
        'operation':'setStatus',
      }
      SupplyApi.saveSupply(form, true)
      .then(data => {
        self.loading = false;
        
        if (data.code == 1) {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          self.getTableList();
        } else {
          self.loading = false;
        }
      })
      .catch(error => {
        self.loading = false;
      });
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/supply/supply/index.vue